<script>
// import svg from '../assets/simulator/symbols.svg';

export default {
	props: {
		name: {
			type: String
		}
	},

}
</script>
<template>
	<span class="s-icon">
		<svg lightning-primitiveIcon_primitiveIcon="" focusable="false" data-key="search" aria-hidden="true" class="slds-icon slds-icon_xx-small"><use lightning-primitiveIcon_primitiveIcon="" :xlink:href="require(`@/assets/simulator/symbols_2.svg`) + '#' + name"></use></svg>
	</span>
</template>
<style lang="scss" scoped>
.s-icon{
	position: relative;
	display: inline-block;
	width: 0.9rem;
	height: 0.9rem;
	margin-top: 0.05rem;
}
svg{
	width: 0.9em;
	height: 0.9em;
	top: 50%;
	left: 50%;
    // margin-top: -.4375rem;
    // line-height: 1;
    border: 0;
	z-index: 2;
	position: absolute;
	transform: translateY(-50%) translateX(-50%);
}
</style>